import classNames from "classnames";
import React from 'react';
import "./Label.scss";

export interface IProps {
    as?:
    | "div"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "h7"
    | "label"
    | "span"
    | "p"
    | "em"
    | "pre";
    role?: string;
    ariaLevel?: number;
    attrs?: any;
    color?: spintrColors;
    className?: string;
    size?: spintrLabelSizes;
    style?: React.CSSProperties;
    weight?: spintrLabelFontweight;
    title?: string;
    children?: React.ReactNode;
    uppercase?: boolean;
    dangerouslySetInnerHTML?: any;
    lang?: string;
    centerText?: boolean;
    fontType?: "display" | "text";
}

export const Label: React.FunctionComponent<IProps> = props => {
    const Tag = props.as! as any;

    return (
        <Tag
            className={classNames(
                props.className,
                "label-component",
                `ft-${props.fontType || "text"}`,
                `fs-${props.size}`,
                {
                    [`fc-${props.color}`]: !!props.color,
                    [`fw-${props.weight}`]: !!props.weight,
                    "uppercase": !!props.uppercase,
                    "subline-letter-spacing": !!props.uppercase,
                    "centerText": !!props.centerText
                }
            )}
            lang={props.lang}
            role={props.role}
            style={props.style}
            title={props.title}
            aria-level={props.ariaLevel}
            dangerouslySetInnerHTML={props.dangerouslySetInnerHTML}
            {...props.attrs}
        >
            {props.children}
        </Tag>
    );
};

Label.defaultProps = {
    as: "div",
    size: "body-1",
};

export default React.memo(Label);
